import type { TranslationKey } from '@/i18n-key';
import type { Pillar } from '@/types/pillars';

/** The pill a pillar status is drawn with, on its tile and in the modal's status options. */
export const PILLAR_STATUS_PILL: Record<
    Pillar['status'],
    {
        variant: 'activeLight' | 'inactiveLight' | 'draftLight';
        status: 'active' | 'inactive' | 'draft';
    }
> = {
    Active: { variant: 'activeLight', status: 'active' },
    Draft: { variant: 'draftLight', status: 'draft' },
    Inactive: { variant: 'inactiveLight', status: 'inactive' },
};

export const PILLAR_STATUS_LABEL_KEY: Record<Pillar['status'], TranslationKey> = {
    Active: 'pillars.status.active',
    Draft: 'pillars.status.draft',
    Inactive: 'pillars.status.inactive',
};
